<template>
  <el-table-column
    prop="title"
    label="Cím"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <span class="el-button el-button--text" @click="$router.replace('/todos/view/' + scope.row.id)">
        {{ scope.row.title }}
      </span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'title',
  };
</script>
